import { computed, type ComputedRef } from 'vue';
import { useI18n } from 'vue-i18n';

/**
 * Single source of truth for the human-readable list of platforms we support.
 *
 * Returns a reactive computed string sourced from `common.supportedPlatformsLabel`
 * so the conjunction localizes naturally ("or" / "o") and the platform set lives
 * in one place. Consumers should pass the value into i18n strings as the
 * `{supportedPlatforms}` interpolation variable rather than hardcoding a literal
 * platform list inside the i18n string itself.
 *
 * Mirror of `apps/backend/src/sms/sms-platform-config.util.ts:SUPPORTED_PLATFORMS`.
 * If the backend SUPPORTED_PLATFORMS list changes, update the
 * `common.supportedPlatformsLabel` i18n strings (en + es) in lockstep.
 */
export function useSupportedPlatformsLabel(): ComputedRef<string> {
  const { t } = useI18n();
  return computed(() => t('common.supportedPlatformsLabel'));
}
